import { Box, Stack, Tab, Tabs, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import CusTextarea from '../../../../../components/material-ui/CusTextarea';
import CusButton from '../../../../../components/material-ui/CusButton';
import { API_CASINO } from '../../../../../api/casino';
import { useAppSelector } from '../../../../../store';
import useToast from '../../../../../hooks/useToast';
import { getAgreement } from './templateAgreement';
import useNumberParams from '../../../../../hooks/useNumberParams';
import FlexContainer from '../../../../../components/material-ui/adaptive/FlexContainer';
import CusTooltip from '../../../../../components/material-ui/CusTooltip';
import TypographyText from '../../../../../components/material-ui/table/TypographyText';
import TabsLanguage from '../../../../../components/widgets/TabsLanguage';
import CasinoBtnSave from '../../../../../components/casino/CasinoBtnSave';
import useBootstrapSize from '../../../../../hooks/useBootstrapSize';

export default function AgreementContent() {
  const { t } = useTranslation();
  const casinoId = useNumberParams('casinoId');
  const { successToast } = useToast();
  const { isShortHeight } = useBootstrapSize();
  const [activeTab, setActiveTab] = useState();
  const [textHash, setTextHash] = useState({});

  useEffect(() => {
    API_CASINO.agreement
      .get({ casinoId })
      .then((e) => {
        const text = e.data.text;
        setTextHash(text);
      })
      .catch(console.error);
  }, []);

  const onSaveClick = () => {
    API_CASINO.agreement
      .set({ casinoId, text: textHash })
      .then((e) => {
        successToast('Information updated successfully');
      })
      .catch(console.error);
  };

  const onTemplateClick = () => {
    const text = getAgreement(activeTab);

    setTextHash((prev) => ({ ...prev, [activeTab]: text }));
  };

  return (
    <Stack display={'flex'} direction={'column'} gap={1}>
      <TabsLanguage lang={activeTab} setLang={setActiveTab} />

      <Box id="box-agreement" key={'box-agreement_' + activeTab}>
        <Stack gap={1}>
          <CusTextarea
            key={'agreement_' + activeTab}
            height={isShortHeight ? undefined : 'calc(100svh - 380px)'}
            label={
              <FlexContainer gap={2}>
                <Stack alignItems={'center'} gap={1} direction={'row'}>
                  <Typography>{t('Agreement')}</Typography>
                  <CusTooltip
                    text={
                      <TypographyText>
                        {t('If you want to use the name of the casino, use')}{' '}
                        <TypographyText sx={{ color: 'text.primary' }} isCopy={'{name_of_casino}'}>
                          {'{name_of_casino}'}
                        </TypographyText>
                      </TypographyText>
                    }
                  />
                </Stack>
                <CusButton
                  size="small"
                  text="Agreement template"
                  variant="outlined"
                  onClick={onTemplateClick}
                  sx={{ height: '28px' }}
                />
              </FlexContainer>
            }
            value={textHash[activeTab]}
            onChange={(value) => {
              setTextHash((prev) => ({ ...prev, [activeTab]: value }));
            }}
          />

          <CasinoBtnSave onClick={onSaveClick} />
        </Stack>
      </Box>
    </Stack>
  );
}
